const Pending = (props) => {
  const formatDate = (date) => {
    const newDate = new Date(date);
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ];
    return `${months[newDate.getMonth()]} ${newDate.getDate()}, ${newDate.getFullYear()}`;
  };
  const fillTable = () => {
    return (
      <>
        {props.usersWaivers.map((uw) =>
          uw.user && uw.waiver && uw.userWaiver ? (
            <tr key={props.usersWaivers.indexOf(uw)}>
              <td className="text-center" style={{ width: '30%' }}>
                {`${uw.user.firstName} ${uw.user.lastName}`}
              </td>
              <td className="text-center" style={{ width: '25%' }}>
                {uw.waiver.name}
              </td>
              <td className="text-center " style={{ width: '25%' }}>
                {formatDate(uw.userWaiver.updatedAt)}
              </td>
              <td className="text-center" style={{ width: '10%' }}>
                <div
                  className="btn btn-sm btn-dark"
                  data-target="#editModal"
                  data-toggle="modal"
                  onClick={() => {
                    props.setUserWaiver(uw.userWaiver.id);
                    props.setUser(uw.user.id);
                  }}
                >
                  Review
                </div>
              </td>
            </tr>
          ) : null
        )}
      </>
    );
  };
  return (
    <div className="table-wrapper-scroll-y my-custom-scrollbar">
      <table className="table table-striped  table-bordered table-hover bg-white mt-1 mr-3">
        <thead className="bg-dark thead-dark">
          <tr>
            <th className="text-center" style={{ width: '30%' }}>
              Name
            </th>
            <th className="text-center" style={{ width: '25%' }}>
              Waiver Type
            </th>
            <th className="text-center" style={{ width: '25%' }}>
              Entered
            </th>
            <th className="text-center" style={{ width: '10%' }}>
              Review
            </th>
          </tr>
        </thead>
        <tbody>{fillTable()}</tbody>
      </table>
    </div>
  );
};
export default Pending;
